import React, { FC, useEffect, useState } from 'react'
import { Row, Col, Card, InputNumber, Form } from 'antd'
import { NavLink, useParams } from 'react-router-dom'
import { ROUTES } from 'routes/constants'

import { TUserProfileBusiness, updateUserProfileRequest } from 'store'
import { useAppDispatch } from 'App/hooks'
import { DefaultFormCard } from 'App/common'

import { MedCloudInfo, CasesInfo, UsersList } from '../index'

const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE'

export type TUserProfileBusinessProps = {
  data: TUserProfileBusiness
}

export const UserProfileBusiness: FC<TUserProfileBusinessProps> = (props) => {
  const { data } = props
  const { id } = useParams<{ id: string }>()
  const dispatch = useAppDispatch()
  const initialValues = {
    allowedCommunities: data.maxCreatedCommunities ?? 1
  }
  const [savedValues, setSavedValues] = useState(initialValues)

  useEffect(() => {
    setSavedValues(initialValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (id !== data.userId) {
    return null
  }

  const handleFormSubmit = (values: { allowedCommunities: number }) => {
    dispatch(
      updateUserProfileRequest({
        id,
        maxCreatedCommunities: values.allowedCommunities
      })
    )

    setSavedValues(values)
  }

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={12}>
        <Card bordered={false}>
          <dl>
            <dt>Business email:</dt>
            <dd>{data.email}</dd>
            <dt>Company type:</dt>
            <dd>{data.companyInfo.name}</dd>
            <dt>Company specialization(s):</dt>
            <dd>
              {data.companyInfo.specializations.length
                ? data.companyInfo.specializations.join(', ')
                : '-'}
            </dd>
            <dt>Location:</dt>
            <dd>
              {data.location.cityName}, {data.location.countryName}
            </dd>
          </dl>
        </Card>
      </Col>

      <Col xs={24} sm={6}>
        <MedCloudInfo data={data.medCloud} />
      </Col>
      <Col xs={24} sm={6}>
        <CasesInfo data={data.cases} />
      </Col>

      <Col xs={24} sm={12}>
        <DefaultFormCard
          title="Community Limits"
          onFormSubmit={handleFormSubmit}
          loadingActionType={UPDATE_USER_PROFILE}
          initialValues={savedValues}
          isCommunities={true}
          savedValues={savedValues}
        >
          {(disabled) => (
            <Row gutter={[20, 20]}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Admin limit"
                  name="allowedCommunities"
                  rules={[
                    { required: true, message: 'Please enter a number' },
                    {
                      type: 'number',
                      min: 1,
                      max: 100,
                      message: 'Value must be between 1 and 100'
                    }
                  ]}
                >
                  <InputNumber min={1} max={100} disabled={disabled} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          )}
        </DefaultFormCard>
      </Col>

      <Col xs={24} sm={12}>
        <Card bordered={false} title="Community Limits" headStyle={{ padding: '4px 24px' }}>
          <Row gutter={[20, 20]}>
            <Col xs={12} sm={12}>
              <dl>
                <dt>Current Communities:</dt>
                <dd>{data.currentCommunitiesCount ?? 0}</dd>
              </dl>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col xs={24} sm={12}>
        <Card bordered={false}>
          <dl>
            <dt>Current Superadmin:</dt>
            <dd>
              <NavLink to={`${ROUTES.USER_MANAGEMENT.PERSONAL_ACCOUNTS}/${data.superadmin.id}`}>
                {data.superadmin.name}
              </NavLink>
            </dd>
            <dt>Current Admin:</dt>
            <dd>&nbsp;</dd>
          </dl>
          <UsersList data={data.admin} />
        </Card>
      </Col>

      <Col xs={24} sm={12}>
        <Card bordered>
          <Row gutter={[20, 20]}>
            <Col xs={24} sm={12}>
              <dl>
                <dt>
                  <b>Associates:</b>
                </dt>
                <dd>{data.partners.business + data.partners.professional}</dd>
                <dt>professionals:</dt>
                <dd>{data.partners.professional}</dd>
                <dt>business:</dt>
                <dd>{data.partners.business}</dd>
              </dl>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}
